import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const ATTRIBUTION_STORAGE_KEY = "quotient-attribution-context"

/** The active attribution context, serialized as a `URLSearchParams` string. */
export const AttributionContextStore: Store<string, "local"> = createStore({
  key: ATTRIBUTION_STORAGE_KEY,
  validator: z.string(),
  storageType: "local",
})
